(function() {
  // Check if fetch is available
  if (typeof window.fetch !== 'function') {
    console.warn('Fetch API not available. Interceptor not loaded.');
    return;
  }

  // 1. Store a reference to the original, built-in fetch function
  const originalFetch = window.fetch;

  // 2. Define the URL we want to intercept
  const targetUrl = 'https://sdk.breeze.in/configs/ihadesigns/config.json';

  // 3. Override the global window.fetch with our new function.
  //    We use (...args) to robustly capture all arguments (e.g., [url, options])
  window.fetch = function(...args) {
    
    // The first argument is the url or Request object
    const url = args[0];
    
    // Check if the request URL matches our target.
    // We check `typeof url` to be safe, as fetch can also accept a Request object.
    if (typeof url === 'string' && url === targetUrl) {

      // It's our target! Call the *original* fetch with the *original* arguments.
      // We return this promise chain, so the original caller behaves as normal.
      return originalFetch(...args)
        .then(response => {
          // Check if the network response was ok
          if (!response.ok) {
            // If the request failed, just return the original
            // error response. No need to modify.
            return response;
          }

          // Get the response as JSON.
          // CRITICAL: We .clone() the response. This allows us to
          // read the JSON, and if it fails, we can still return the
          // original response without a "body already consumed" error.
          return response.clone().json().then(data => {

            let modifiedData;

            try {
              // --- YOUR MODIFICATION LOGIC GOES HERE ---

              // Define the new payment option to add
              const newPaymentOption = {
                "title": "INTERNATIONAL OPTIONS",
                "paymentOptions": [
                  {
                    "image": "https://sdk.breeze.in/gallery/logos/release/ihadesigns/social-logo-4rCBu5xOiyvH-kIOqtOTe.webp",
                    "label": "PayPal & International Cards",
                    "description": "Pay with PayPal or international cards",
                    "type": "Instrument",
                    "source": "CPO",
                    "widget": "NativeRedirect",
                    "pm": "NATIVE",
                    "pmt": "CUSTOM"
                  }
                ]
              };
              
              // Check if paymentMethodsConfig exists and is an array
              if (data.paymentMethodsConfig && Array.isArray(data.paymentMethodsConfig)) {
                
                // Create a new array with the original items + new item
                const newPaymentMethodsConfig = [
                  ...data.paymentMethodsConfig, // Array spread is ES2015, fine.
                  newPaymentOption
                ];

                // Create modifiedData using Object.assign() for max compatibility
                // This creates a new object, copies 'data' into it,
                // and then overwrites 'paymentMethodsConfig' with our new array.
                modifiedData = Object.assign({}, data, {
                  paymentMethodsConfig: newPaymentMethodsConfig
                });

              } else {
                // If it doesn't exist or isn't an array, just log a warning
                // and return the original data.
                console.warn(`'paymentMethodsConfig' not found or is not an array in the response.`);
                modifiedData = data; // Set to original data
              }
              // --- END OF MODIFICATION LOGIC ---

            } catch (e) {
              // FAILSAFE: If the modification logic has an error,
              // log it and return the original data so the app doesn't break.
              console.error(`Error during config modification for ${targetUrl}:`, e);
              modifiedData = data;
            }

            console.log('Modified config data:', modifiedData);

            // 4. Create a new, fake Response object.
            // We stringify our modified data and use the original
            // response's status, statusText, and a *new* copy of the headers.
            const newResponse = new Response(JSON.stringify(modifiedData), {
              status: response.status,
              statusText: response.statusText,
              headers: new Headers(response.headers) // Use new Headers()
            });

            // Ensure 'Content-Type' is set to json
            newResponse.headers.set('Content-Type', 'application/json');

            // Return our *new* response.
            return newResponse;
          })
          .catch(error => {
            // This .catch() handles errors from response.clone().json()
            // This happens if the response was not valid JSON (e.g., an HTML error page)
            console.error(`Error parsing JSON response for ${targetUrl}:`, error);
            // Return the *original* (un-cloned) response for the app to handle.
            // This is safe because we only tried to read the clone.
            return response;
          });
        })
        .catch(error => {
          // Handle any errors from the *original* fetch call (e.g., network down)
          console.error(`Error during fetch interception for ${url}:`, error);
          // Re-throw the error so the original caller's .catch() block triggers
          throw error;
        });
    }

    // 5. If the URL didn't match, just call the
    //    original fetch function with the original arguments.
    return originalFetch(...args);
  };
})();